/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Box,
} from '@material-ui/core'
import { useParams } from '@reach/router'
import { useDispatch } from 'react-redux'
import { DeleteOutlined } from '@material-ui/icons'

import Button from '_components/button'
import { cancelServiceOrderApproved } from '_modules/service-orders/actions'

import useStyles from './styles'

export default function CancelApprovedModal(props) {
  const { cancelApprovedModal, setCancelApprovedModal } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const { serviceOrderId } = useParams()

  const handleConfirm = async () => {
    await Promise.resolve(dispatch(cancelServiceOrderApproved(serviceOrderId))).then(
      setCancelApprovedModal({ ...cancelApprovedModal, isOpen: false })
    )
    window.location.reload()
  }

  function GetIconButton() {
    return (
      <IconButton disableRipple className={classes.titleIconTrash}>
        <DeleteOutlined className={classes.iconeSVG} />
      </IconButton>
    )
  }

  return (
    <Dialog open={cancelApprovedModal.isOpen} classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>
        <Box mt={10} />
        <GetIconButton />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="">{cancelApprovedModal.subTitle}</Typography>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          variant="outlined"
          color="red"
          className={classes.button}
          onClick={() => setCancelApprovedModal({ ...cancelApprovedModal, isOpen: false })}
        >
          {cancelApprovedModal.textNoButton ? cancelApprovedModal.textNoButton : 'Não'}
        </Button>
        {cancelApprovedModal ? (
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleConfirm}
          >
            {cancelApprovedModal.textYesButton ? cancelApprovedModal.textYesButton : 'Sim'}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => setCancelApprovedModal({ ...cancelApprovedModal, isOpen: false })}
          >
            {cancelApprovedModal.textYesButton ? cancelApprovedModal.textYesButton : 'Sim'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
